import { NavigateFunction } from "react-router-dom";
import { apiFetchRoute } from "./apiFetchRoute";

export const handleLogout = async (navigate: NavigateFunction) => {
  try {
    const response = await apiFetchRoute("postLogout", undefined);

    if (response.ok) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("accountStorage");
      localStorage.removeItem("cookieConsent");
      navigate("/login");
    } else {
      console.error("Erreur:", response.status);
    }
  } catch (error) {
    console.error("Erreur lors de la requête:", error);
  }
};
